import { DetailsVariants } from 'pages/terms-and-policies/header/DetailsContainer'
import { DocumentAuthor } from 'pages/terms-and-policies/models'
import React from 'react'

type TermsAndPoliciesContactPersonProps = {
  variant: DetailsVariants
  author?: DocumentAuthor
}

export const TermsAndPoliciesContactPerson = ({
  variant,
  author,
}: TermsAndPoliciesContactPersonProps) => {
  return (
    <div
      className={`flex flex-col w-full justify-start items-center gap-4 text-center ${
        variant === 'dark' ? 'text-white' : 'text-[#001a3d]'
      }`}
    >
      <div className='font-medium text-xs md:text-lg md:font-bold leading-normal '>
        Got a question?
      </div>
      <div className='flex flex-col justify-between gap-1 text-[10px] md:text-sm font-normal'>
        <p>{author ? author.role : 'Director of Operations'}</p>
        <p>{author ? author.name : 'Fraser J Matcham'}</p>
        <p>{author ? author.email : 'fraser@legalutopia.co.uk'}</p>
      </div>
    </div>
  )
}
